import gql from 'graphql-tag';
import SUPPORT_TOPIC_FRAMENT from '../fragments/support-topic';
import SUPPORT_CATEGORY_FRAGMENT from '../fragments/support-category';
import TAG_FRAGMENT from '../fragments/tag';
const GET_SUPPORT_TOPICS = gql`
  query getSupportTopics($where: SupportTopicsWhereInput) {
    supportTopics(where: $where) {
      ...BaseSupportTopic
      supportCategories {
        ...BaseSupportCategory
      }
      tags {
        ...BaseTag
      }
    }
  }
  ${SUPPORT_TOPIC_FRAMENT}
  ${SUPPORT_CATEGORY_FRAGMENT}
  ${TAG_FRAGMENT}
`;

export default GET_SUPPORT_TOPICS;
